import React, { useState} from 'react';
import { FormControl } from "react-bootstrap";
import {useStores} from "../../../stores/Context";
import {observer} from "mobx-react";

const styles = {
    title: {
        color: 'var(--SEIZO-dark, #002335)',
        fontFamily: '"Sofia Pro", serif',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '130%',
        float: 'left',
        marginBottom: '.5em',
    },
    input : {
        display: 'flex',
        minHeight: '160px',
        padding: '12px 18px',
        alignItems: 'flex-start',
        gap: '18px',
        borderRadius: '4px',
        border: '1px solid var(--icon-black, #002335)',
        backgroundColor: 'var(--icon-light-BG, #FBFDFE)',
        /* Font style */
        color: 'var(--icon-black, #002335)',
        fontFamily: 'Nunito, serif',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '130%',
    }
}

const CreateObjectText = observer(({idObjet, data = null}) => {
    const {niveauxIndicateurStore} = useStores();
    const [textValue, setTextValue] = useState(data ? data?.config.text_contenu : '')

    const handleGetText = (value) => {
        setTextValue(value)
        niveauxIndicateurStore.objetTextValue = value;
    }

    return (
        <div className={'mt-0'}>
            <p style={styles.title}>Texte :</p>
            <FormControl style={styles.input} as="textarea" value={textValue} onChange={(e) => {
                handleGetText(e.target.value)
            }}/>
        </div>
    );
});

export default CreateObjectText;
